// @flow
import React from 'react';
import Button from '@atlaskit/button/new';
import { FormFooter } from '@atlaskit/form';
import { FooterArea } from 'modules/checkout/styled';
import type { QuotePageProps } from 'modules/checkout/duck/model';

export default (props: QuotePageProps) => (
  <FormFooter>
    <FooterArea>
      <Button type="submit" appearance="primary" isLoading={props.submission.inProgress}>
        Continue
      </Button>
    </FooterArea>
  </FormFooter>
);
